import { Tr, Td, Skeleton } from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';

import { AccountSelectionRowProps } from '../../../../../../types/plaid.d';
import { dollarNumberWithCommas } from '~/packages/common-frontend/utils';

export const AccountSelectionRow = ({
  institutionAccount,
  cashBalancePreference,
  isLoading,
}: AccountSelectionRowProps) => {
  const {
    name,
    mask,
    current,
    available,
    currency,
    retrievedAt,
  } = institutionAccount;

  const formattedLastRefresh = commonDate.epochToLocaleDateString(retrievedAt);

  const preferredCashBalanceAmount =
    cashBalancePreference === 'available' ? available : current;

  const cashBalanceLabel = preferredCashBalanceAmount
    ? dollarNumberWithCommas(preferredCashBalanceAmount)
    : 'N/A';

  const institutionName = mask ? `${name} (${mask})` : name;

  return (
    <Tr className="institutions-accounts-row">
      <Td>{institutionName}</Td>
      <Td>{institutionAccount.type || 'N/A'}</Td>
      <Td>{isLoading ? <Skeleton height="20px" /> : cashBalanceLabel}</Td>
      <Td>{currency || 'N/A'}</Td>
      <Td>{isLoading ? <Skeleton height="20px" /> : formattedLastRefresh}</Td>
    </Tr>
  );
};
